import { create } from 'zustand';
import { AdditionalFields } from '@ohpen/enso-ui';
import { ActionEntityType, getAllAdditionalFields } from '@pmp/api';

type AdditionalFieldsStore = {
  isLoadingAdditionalFields: boolean;
  getAdditionalFields: (entityType: ActionEntityType) => Promise<AdditionalFields>;
};

export const useAdditionalFieldsStore = create<AdditionalFieldsStore>(set => {
  const additionalFields: Partial<Record<ActionEntityType, AdditionalFields>> = {};
  const pendingRequests: Partial<Record<ActionEntityType, Promise<AdditionalFields>>> = {};

  return {
    isLoadingAdditionalFields: false,

    getAdditionalFields: async (entityType: ActionEntityType) => {
      const cached = additionalFields[entityType];
      if (cached) return cached;

      const pending = pendingRequests[entityType];
      if (pending) return pending;

      set({ isLoadingAdditionalFields: true });

      const request = (async (): Promise<AdditionalFields> => {
        // TODO : Remove this condition when the API is ready
        const { data } = entityType === ActionEntityType.PRODUCTS ? await getAllAdditionalFields() : { data: {} };
        additionalFields[entityType] = data || {};
        return additionalFields[entityType];
      })();

      pendingRequests[entityType] = request;

      // Cleanup is chained rather than placed in the async body: without an await the body would run
      // synchronously and clear the entry before it is registered above.
      return request
        .catch(error => {
          console.error('Failed to load additional fields:', error);
          throw error;
        })
        .finally(() => {
          delete pendingRequests[entityType];
          set({ isLoadingAdditionalFields: Object.keys(pendingRequests).length > 0 });
        });
    },
  };
});
